import React from "react";
import ReactDOM from "react-dom";
import { ApolloProvider } from "@apollo/react-hooks";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store from "reduxStore";
import App from "./App";
import { gqlClient } from "api/paymentManagement/client";
import "service/firebase/init";
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'jquery/dist/jquery.min.js';
import 'popper.js';
import "css/index.scss"
import './index.css';
import {  MediaQueryProvider  } from 'context/mediaQueryContext';
import { RefProvider } from 'context/refContext';
import structuredClone from '@ungap/structured-clone';


async function init() {

  if (typeof globalThis === 'undefined') {
    var globalThis = typeof global !== 'undefined' ? global : window;
  }

  if (!('structuredClone' in globalThis)) {
    globalThis.structuredClone = structuredClone;
  }
  
  console.log('which emial:', process.env.REACT_APP_PAYMENT_SUCCESS_EMAIL_RECEIVER);

  const render = () =>
    ReactDOM.render(
      <ApolloProvider client={gqlClient}>
        <Provider store={store}>
          <MediaQueryProvider>
            <RefProvider>
              <Router>
            <App />
          </Router>
          </RefProvider>

          </MediaQueryProvider>
        </Provider>
      </ApolloProvider>,
      document.getElementById("root")
    );
  render();
  // store.subscribe(render);
}

init();
